<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <titleConfig
          :title="langSet == 'cn' ? content.name : content.name_en"
          :type="2"
        ></titleConfig>
      </div>
      <template
        v-if="
          content.button &&
          content.button.length > 0 &&
          content.button[0].button_title
        "
      >
        <div class="btn_list flex flex_content_center flex_items_center">
          <div
            class="btn_item flex flex_items_center flex_content_sb"
            :class="{ green_bg: index % 2 === 1 }"
            v-for="(item, index) in content.button"
            :key="index"
            @click="toLink(item)"
          >
            <span>{{
              langSet == "cn" ? item.button_title : item.button_title_en
            }}</span>
            <el-image
              class="btn_icon"
              :src="require('../../assets/api_arrow.png')"
            ></el-image>
          </div>
        </div>
      </template>

      <div
        class="html_wrap"
        v-html="langSet == 'cn' ? content.content : content.content_en"
      ></div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { webAbout } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      content: {
        button: [],
      },
      id: 0,
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    //25.9.15 获取主办方内容 dxm
    // 1：展会介绍
    // 2：展位图
    // 3：展商手册
    // 4：展会安排
    // 5：商旅服务
    // 6：会议赞助
    // 7：医药原材料
    this.getWebAbout(this.id);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getWebAbout(type) {
      let data = {
        type,
      };
      const res = await webAbout(data);
      this.content = res.data;
    },
    toLink(item) {
      if (item.button_type == "跳转外链") {
        window.open(
          this.langSet == "cn" ? item.button_url : item.button_url_en,
          "_blank"
        );
      } else {
        this.$router.push({
          path: this.langSet == "cn" ? item.button_url : item.button_url_en,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ p img {
  margin: 0 auto;
  display: inline-block;
  max-width: 100%;
}
.content_wrap {
  padding: 80px 0;
  .content_title {
    margin-bottom: 31px;
  }
  .btn_list {
    .btn_item {
      min-width: 280px;
      height: 60px;
      font-size: 18px;
      color: #fff;
      cursor: pointer;
      padding: 0 120px 0 44px;
      box-sizing: border-box;
      background: #1d2379;
      border-radius: 30px;
      margin: 0 15px;
      overflow: hidden;
      position: relative;
      z-index: 1;
      transition: background 0.3s;
      .btn_icon {
        width: 60px;
        height: 40px;
        position: absolute;
        right: 10px;
        transition: right 0.2s;
      }
      &::before {
        content: "";
        z-index: -1;
        position: absolute;
        top: 50%;
        left: 100%;
        margin: -15px 0 0 1px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #e9e9f2;
        -webkit-transform-origin: 100% 50%;
        transform-origin: 100% 50%;
        -webkit-transform: scale3d(1, 2, 1);
        transform: scale3d(1, 2, 1);
        -webkit-transition: -webkit-transform 0.2s, opacity 0.2s;
        transition: transform 0.2s, opacity 0.2s;
        -webkit-transition-timing-function: cubic-bezier(0.7, 0, 0.9, 1);
        transition-timing-function: cubic-bezier(0.7, 0, 0.9, 1);
      }
      &:hover {
        color: #001a33;
        text-align: center;
        justify-content: center;
        padding: 0 82px;
        background: #e9e9f2;
        &::before {
          -webkit-transform: scale3d(13, 13, 1);
          transform: scale3d(13, 13, 1);
        }
        .btn_icon {
          right: -120px;
        }
      }
    }
    .green_bg {
      background: #90c31f;
      &::before{
        content: "";
        background: #EBF5D4;
      }
      &:hover{
        background: #EBF5D4;
      }
    }
  }
  .html_wrap {
    padding: 47px 0;
    min-height: 500px;
    /deep/ li {
      list-style: inherit;
    }
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content_title {
      margin-bottom: 0.58rem;
    }
    .btn_list {
      flex-wrap: wrap;
      .btn_item {
        width: 5.38rem;
        min-width: 5.38rem;
        height: 1.1rem;
        font-size: 0.29rem;
        margin: 0;
        margin-bottom: 0.38rem;
        .btn_icon {
          width: 1.15rem;
          height: 0.71rem;
          margin-left: 0.3rem;
        }
      }
    }
    .html_wrap {
      padding: 0.2rem 0;
    }
  }
}
</style>